import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyCkJW7sToI8CshqeTty58en7JBSyTASn6Y",
  authDomain: "ecommerce-abdaf.firebaseapp.com",
  projectId: "ecommerce-abdaf",
  storageBucket: "ecommerce-abdaf.appspot.com",
  messagingSenderId: "957567067084",
  appId: "1:957567067084:web:49335e09ac83ea8b907369",
};
const app = initializeApp(firebaseConfig);
export default app;
